import { CheckCircleOutline, ErrorOutline, HighlightOffOutlined } from '@material-ui/icons';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import trI18n from '@/common/utils/trI18n';
import tr from '@/common/utils/tr';

const renderSettingApiStatus = status => {
    switch (status) {
        case Constant.MCP_SERVER_CONNECT_STATUS.SUCCESS:
            return (
                <div className="mcp-server-status mcp-server-active">
                    <div className="mcp-server-item-status color-success">
                        <CheckCircleOutline />
                        {trI18n('MCP_SERVER_SETTING_STATUS_SUCCESS')}
                    </div>
                </div>
            );
        case Constant.MCP_SERVER_CONNECT_STATUS.NOT_CONNECT:
            return (
                <div className="mcp-server-status">
                    <div className="mcp-server-item-status color-warning">
                        <ErrorOutline />
                        {trI18n('MCP_SERVER_SETTING_STATUS_NOT_CONNECT')}
                    </div>
                </div>
                
            );
        case Constant.MCP_SERVER_CONNECT_STATUS.FAIL:
            return (
                <div className="mcp-server-status mcp-server-active">
                    <div className="mcp-server-item-status color-error">
                        <HighlightOffOutlined />
                        {trI18n('MCP_SERVER_SETTING_STATUS_ERROR')}
                    </div>
                </div>
            );
        default:
            return null;
    }
};

const getFieldLabel = fieldKey => {
    const label = {
        connectId: '接続ID',
        authMethod: '認証方式',

        type: '外部連携種類',
        openaiConnectorId: "コネクタ連携先",
        
        // Oauth2Setting
        redirectUrl: 'OAuth Redirect URL',
        clientId: 'クライアントID',
        secret: 'クライアントシークレット',
        authUrl: '認可URL',
        tokenUrl: 'トークンURL',
        scope: 'スコープ',
        
        // JwtSetting
        iss: 'クライアントID',
        sub: '主体（しゅたい）',
        aud: 'オーディエンス',

        // APIKeySetting
        apiKey: 'APIキー',

        // BearerSetting
        bearer: 'Bearerトークン',

        serverName: '外部連携名',
        serverURL: '外部連携URL',
        isActiveCorp: '有効/無効',
        memo: 'メモ',
    };

    return tr(label[fieldKey] || '');
};

const openaiConnectorList = [
    {
        label: 'Google Calendar',
        value: 'connector_googlecalendar',
        scopes: [
            { label: 'userinfo.email', value: 'https://www.googleapis.com/auth/userinfo.email' },
            {
                label: 'userinfo.profile',
                value: 'https://www.googleapis.com/auth/userinfo.profile'
            },
            { label: 'calendar.events', value: 'https://www.googleapis.com/auth/calendar.events' }
        ]
    },
    {
        label: 'Dropbox',
        value: 'connector_dropbox',
        scopes: [
            { label: 'files.metadata.read', value: 'files.metadata.read' },
            { label: 'files.content.read', value: 'files.content.read' },
            { label: 'account_info.read', value: 'account_info.read' }
        ]
    },
    {
        label: 'Gmail',
        value: 'connector_gmail',
        scopes: [
            { label: 'userinfo.email', value: 'https://www.googleapis.com/auth/userinfo.email' },
            {
                label: 'userinfo.profile',
                value: 'https://www.googleapis.com/auth/userinfo.profile'
            },
            { label: 'gmail.modify', value: 'https://www.googleapis.com/auth/gmail.modify' }
        ]
    },
    
    {
        label: 'Google Drive',
        value: 'connector_googledrive',
        scopes: [
            { label: 'userinfo.email', value: 'https://www.googleapis.com/auth/userinfo.email' },
            {
                label: 'userinfo.profile',
                value: 'https://www.googleapis.com/auth/userinfo.profile'
            },
            { label: 'drive.readonly', value: 'https://www.googleapis.com/auth/drive.readonly' }
        ]
    },
    {
        label: 'Microsoft Teams',
        value: 'connector_microsoftteams',
        scopes: [
            { label: 'Chat.Read', value: 'https://graph.microsoft.com/Chat.Read' },
            {
                label: 'ChannelMessage.Read.All',
                value: 'https://graph.microsoft.com/ChannelMessage.Read.All'
            },
            { label: 'User.Read', value: 'https://graph.microsoft.com/User.Read' }
        ]
    },
    {
        label: 'Outlook Calendar',
        value: 'connector_outlookcalendar',
        scopes: [
            { label: 'Calendars.Read', value: 'https://graph.microsoft.com/Calendars.Read' },
            { label: 'User.Read', value: 'https://graph.microsoft.com/User.Read' }
        ]
    },
    {
        label: 'Outlook Email',
        value: 'connector_outlookemail',
        scopes: [
            { label: 'Mail.Read', value: 'https://graph.microsoft.com/Mail.Read' },
            { label: 'User.Read', value: 'https://graph.microsoft.com/User.Read' }
        ]
    },
    {
        label: 'SharePoint',
        value: 'connector_sharepoint',
        scopes: [
            { label: 'Sites.Read.All', value: 'https://graph.microsoft.com/Sites.Read.All' },
            { label: 'Files.Read.All', value: 'https://graph.microsoft.com/Files.Read.All' },
            { label: 'User.Read', value: 'https://graph.microsoft.com/User.Read' }
        ]
    }
];

const EXCLUDED_FIELDS = [
    'id',
    'affiliationOrganization',
    'affiliationProject',
    'ownerBy',
    'connectId',

    // 'oauth2Setting',
    'accessToken',
    'refreshToken',

    // 'jwtSetting',
    'exp',
    'accessToken',

    // 'baseSetting',
    'metaData',

    'status',
    'creator',
    'createdAt',
    'updator',
    'updatedAt',
    'deletedAt',
    'lastTestedAt',

    'memo',
    'projectActived',
    'testResult'
];

const AUTH_SETTING_FIELD_KEYS = ['oauth2Setting', 'jwtSetting', 'apiKeySetting', 'bearerSetting'];

const AUTH_METHOD_OPTIONS = [
    { label: 'OAuth2', value: 'oauth2Setting'},
    { label: 'JWT', value: 'jwtSetting', isdisable: true },
    { label: 'APIキー', value: 'apiKeySetting' },
    { label: 'Bearer', value: 'bearerSetting' },
    { label: '無し', value: 'none' }
];

// MCP type options
const MCP_TYPE_OPTIONS = [
    { label: 'Default', value: Constant.MCP_SERVER_TYPE.MCP_SERVER },
    { label: 'OpenAI Connector', value: Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR }
];

// define input attributes & input validate rules ...
const fieldMeta = {
    serverName: { required: true, isAlphaNum_: true, maxLength: 128 },
    serverURL: { required: true, isUrl: true },
    type: { required: true },
    openaiConnectorId: { required: true },

    authMethod: { required: true },
    password: { type: 'password' },
    privateKey: { multiline: true },
    apiKeyValue: { multiline: true },
    // apiKey: { required: true },
    // bearer: { required: true },
    isActiveCorp: { required: true },
    memo: { multiline: true }, 
    // redirectUrl: { isUrl: true },
    authUrl: { isUrl: true, required: true },
    tokenUrl: { isUrl: true, required: true },
    clientId: {required: true},
    scope: {required: true},
    secret: {required: true}
};

const getFieldMeta = (key, parentKey = null) => {
    const fullKey = parentKey ? `${parentKey}.${key}` : key;
    return fieldMeta[fullKey] || fieldMeta[key] || {};
};

const checkInValidInput = (fieldKey, fieldValue, meta, parentKey = null, errors = {}) => {
    const rules = [
        {
            check: () => meta.required && !fieldValue?.toString().trim(),
            message: trI18n('MSG-CM-REQUIRED-INPUT')
        },
        {
            check: () => meta.isBase62 && fieldValue && !Utils.isBase62(fieldValue),
            message: trI18n('MSG_INVALID_BASE_62_VALUE')
        },
        {
            check: () =>
                meta.isAlphaNum_ && fieldValue && !Utils.isValidAlphaNumericUnderscore(fieldValue),
            message: trI18n('MSG_INVALID_ALPHA_NUMERIC_UNDER_SCORE')
        },
        {
            check: () => meta.minLength && fieldValue.length < meta.minLength,
            message: trI18n('COMMSG026').replace('{{minLength}}', meta.minLength)
        },
        {
            check: () => meta.maxLength && fieldValue.length > meta.maxLength,
            message: trI18n('COMMSG027').replace('{{maxLength}}', meta.maxLength)
        },
        {
            check: () => {
                if (!meta.isUrl) return false;
                try {
                    new URL(fieldValue);
                    return false;
                } catch {
                    return true;
                }
            },
            message: trI18n('MSG_INVALID_URL_VALUE')
        },
        {
            check: () => {
                if (!meta.isJson) return false;
                if (Utils.isEmptyString(fieldValue)) return false; // only validate when fieldValue.length > 0
                try {
                    const value = JSON.parse(fieldValue);
                    const isNotObj = !Utils.isObjectType(value);
                    return isNotObj;
                } catch {
                    return true;
                }
            },
            message: trI18n('MSG_INVALID_JSON_VALUE')
        },
        {
            check: () => {
                if (!meta.isNotEmptyJson) return false;
                try {
                    const value = JSON.parse(fieldValue);
                    const isEmptyObj = !Utils.isNotEmptyObj(value);
                    return isEmptyObj;
                } catch {
                    return true;
                }
            },
            message: trI18n('MSG_INVALID_JSON_VALUE')
        }
    ];

    const matchedRule = rules.find(rule => rule.check());
    const error = matchedRule?.message || '';

    if (parentKey) {
        return {
            ...errors,
            [parentKey]: {
                ...(errors[parentKey] || {}),
                [fieldKey]: error
            }
        };
    }

    return {
        ...errors,
        [fieldKey]: error
    };
};
// comment for now
// const handleValidateFormData = formData => {
//     let isErrors = false;
//     let errors = {};
//     for (let key of Object.keys(formData)) {
//         if (EXCLUDED_FIELDS.includes(key)) continue;
//         if (AUTH_SETTING_FIELD_KEYS.includes(key)) {
//             const authMethodValue = formData?.authMethod || '';
//             if (Utils.isEmptyString(authMethodValue) || authMethodValue === 'none') {
//                 continue;
//             }
//             const authSettingKey = authMethodValue;
//             const authSettingObj = formData[authSettingKey];
//             for (let settingKey of Object.keys(authSettingObj)) {
//                 const settingMeta = getFieldMeta(settingKey, authSettingKey);
//                 const settingValue = formData?.[authSettingKey]?.[settingKey] ?? '';
//                 const result = checkInValidInput(
//                     settingKey,
//                     settingValue,
//                     settingMeta,
//                     authSettingKey,
//                     errors
//                 );
//                 if (!Utils.isEmptyString(result?.[authSettingKey]?.[settingKey])) {
//                     isErrors = true;
//                 }
//                 errors = result;
//             }
//             continue;
//         }
//         const meta = getFieldMeta(key, null);
//         const value = formData?.[key] ?? '';
//         const result = checkInValidInput(key, value, meta, null, errors);
//         if (!Utils.isEmptyString(result?.[key])) {
//             isErrors = true;
//         }
//         // validate schema input params
//         if (key === 'testParam' && !Utils.isEmptyString(formData?.['testParam'])) {
//             const schemaStr = formData?.['inputParamDesc'];
//             const dataStr = formData?.['testParam'];
//             const { valid, message } = validateJsonByFullTypeSchema(schemaStr, dataStr);
//             if (!valid) {
//                 result.testParam = message
//             }
//         }
//         errors = result;
//     }
//     return { isErrors, errors };
// };

const handleValidateAuthFields = (formData, errors) => {
    let isErrors = false;
    const authMethodValue = formData?.authMethod || '';
    if (Utils.isEmptyString(authMethodValue) || authMethodValue === 'none') {
        return { isErrors, errors };
    }

    const authSettingKey = authMethodValue;
    const authSettingObj = formData[authSettingKey] || {};

    for (let settingKey of Object.keys(authSettingObj)) {
        const settingMeta = getFieldMeta(settingKey, authSettingKey);
        const settingValue = authSettingObj?.[settingKey] ?? '';
        const result = checkInValidInput(
            settingKey,
            settingValue,
            settingMeta,
            authSettingKey,
            errors
        );
        if (!Utils.isEmptyString(result?.[authSettingKey]?.[settingKey])) {
            isErrors = true;
        }
        errors = result;
    }

    return { isErrors, errors };
};
const handleValidateNormalField = (key, formData, errors) => {
    let isErrors = false;
    const meta = getFieldMeta(key, null);
    const value = formData?.[key] ?? '';

    const mcpServerType = formData?.type;
    if (key === 'serverURL') {
        if (mcpServerType === "OPENAI_CONNECTOR") return { isErrors };
    }

    if (key === 'openaiConnectorId') {
        if (mcpServerType === "MCP_SERVER") return { isErrors };
    }


    const result = checkInValidInput(key, value, meta, null, errors);
    if (!Utils.isEmptyString(result?.[key])) {
        isErrors = true;
    }

    // validate schema input params
    if (key === 'testParam' && !Utils.isEmptyString(value)) {
        const schemaStr = formData?.['inputParamDesc'];
        const { valid, message } = validateJsonByFullTypeSchema(schemaStr, value);
        if (!valid) {
            result.testParam = message;
        }
    }

    return { isErrors, errors: result };
};
const handleValidateFormData = (formData, isNotValidateName) => {
    let isErrors = false;
    let errors = {};

    let excludedField = [ ...EXCLUDED_FIELDS ];
    if (isNotValidateName) {
        excludedField = [...excludedField, Constant.MCP_SERVER_TEXT.SERVER_NAME]
    }
    for (let key of Object.keys(formData)) {
        if (excludedField.includes(key)) continue;

        if (AUTH_SETTING_FIELD_KEYS.includes(key)) {
            const result = handleValidateAuthFields(formData, errors);
            isErrors = isErrors || result.isErrors;
            errors = {...errors, ...result.errors};
            continue;
        }

        const result = handleValidateNormalField(key, formData, errors);
        isErrors = isErrors || result.isErrors;
        errors = {...errors, ...result.errors};
    }

    return { isErrors, errors };
};

const isValidJSON = str => {
    try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
    } catch {
        return false;
    }
};

const getType = value => {
    if (value === null) return 'null';
    if (Array.isArray(value)) return 'array';
    if (typeof value === 'bigint') return 'bigint';
    if (typeof value === 'symbol') return 'symbol';
    if (typeof value === 'undefined') return 'undefined';
    return typeof value;
};


const validateJsonByFullTypeSchema = (schemaStr, dataStr) => {
    if (!isValidJSON(schemaStr)) return { valid: false, message: trI18n('MSG_INVALID_JSON_VALUE') };
    if (!isValidJSON(dataStr)) return { valid: false, message: trI18n('MSG_INVALID_JSON_VALUE') };

    const schema = JSON.parse(schemaStr);
    const data = JSON.parse(dataStr);

    const allowedTypes = ['string', 'number', 'boolean', 'object', 'array'];

    for (const [key, expectedType] of Object.entries(schema)) {
        if (!allowedTypes.includes(expectedType)) {
            return {
                valid: false,
                message: trI18n('MSG_INVALID_SCHEMA_DATA')
            };
        }

        const actualValue = data[key];

        const actualType = getType(actualValue);

        if (actualValue === undefined || actualValue === null) {
            return {
                valid: false,
                message: trI18n('MSG_INVALID_SCHEMA_DATA')
            };
        }

        if (actualType !== expectedType) {
            return {
                valid: false,
                message: trI18n('MSG_INVALID_SCHEMA_DATA')
            };
        }
    }

    return { valid: true };
};

const renderSettingMCPServer = (isActiveData, callUpdateActive, mcpServerData, isCorpSetting, panelType = '') => {
    const inputId = `mcp-server-active-project-${mcpServerData?.id}-${isCorpSetting}-${panelType}`;
    return (
        <div className={`mcp-server-status`}>
            <div className="switch-check mcp-server-setting-function">
                <input
                    name="MCPServer"
                    id={inputId}
                    type="checkbox"
                    disabled={false}
                    checked={isActiveData}
                    onChange={e => {
                        callUpdateActive(!isActiveData, mcpServerData);
                    }}
                />
                <label htmlFor={inputId} aria-label="Activate MCP Server"></label>
            </div>
        </div>
    );
};

export {
    EXCLUDED_FIELDS,
    AUTH_METHOD_OPTIONS,
    MCP_TYPE_OPTIONS,
    openaiConnectorList,
    AUTH_SETTING_FIELD_KEYS,
    renderSettingApiStatus,
    getFieldLabel,
    getFieldMeta,
    checkInValidInput,
    handleValidateFormData,

    renderSettingMCPServer,
};
